export enum SearcherStatus {
    ERROR = 'error',
    INVALID_IDENTIFIER = 'invalidIdentifier',
    NO_SEARCH_DONE_YET = 'noSearchDoneYet',
    SEARCH_CLEARED = 'searchCleared',
    SEARCH_SUCCESS = 'searchSuccess',
    TOO_MANY_RESULTS = 'tooManyResults',
    NO_RESULTS = 'noResults'
}
